export const ASSET_3D_SUPPORTED_EXTENSIONS: readonly string[] = ['glb', 'gltf', 'obj', 'stl'];

export const ASSET_3D_ACCEPT_ATTRIBUTE: string = ASSET_3D_SUPPORTED_EXTENSIONS
	.map((ext) => `.${ext}`)
	.join(',');

export function getAsset3DExtension (fileName: string): string {
	return (fileName.split('.').pop() || '').toLowerCase();
}

export function isAsset3DFileName (fileName: string): boolean {
	return ASSET_3D_SUPPORTED_EXTENSIONS.includes(getAsset3DExtension(fileName));
}

export function inferAsset3DContentType (file: File): string {
	if (file.type) return file.type;
	const ext = getAsset3DExtension(file.name);
	if (ext === 'glb') return 'model/gltf-binary';
	if (ext === 'gltf') return 'model/gltf+json';
	if (ext === 'obj') return 'model/obj';
	if (ext === 'stl') return 'model/stl';
	return 'application/octet-stream';
}
